/**
 * Typography tokens. Three families — `ui` (inherit the app font for
 * gameplay windows), `mono` (debug/diagnostic readouts), and `display`
 * (Cinzel — the engraved-caps seasoning for titles/moments only, never
 * body, never below ~14px). Sizes are numbers (px) matching the existing
 * HUD_TYPOGRAPHY scale 1:1.
 *
 * `display` mirrors the `--helix-font-display` CSS var (src/client/styles/
 * variables.css) 1:1 — keep the two in sync. Cinzel is self-hosted via
 * @font-face in index.css (no external CDN); Georgia is the serif fallback
 * if the face fails to load.
 */
export const FONTS = {
  ui: 'inherit',
  mono: 'monospace',
  display: "'Cinzel', 'Georgia', serif",
} as const;

export const FONT_SIZE = {
  xs: 10,
  sm: 11,
  md: 12,
  lg: 14,
  xl: 16,
  xxl: 18,
  title: 24,
} as const;

export const FONT_WEIGHT = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
} as const;

export const LETTER_SPACING = {
  normal: 'normal',
  wide: '0.08em',
} as const;

export type FontSizeKey = keyof typeof FONT_SIZE;
